export default "__VITE_ASSET__CgqsXZx8__"